import { FC, useState } from 'react';
import { useTranslation } from '@packages/utils';
import { Modal } from 'components/Base/Modal';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { EIconNames } from 'components/Base/Icon';
import { useCancelActionMutation } from 'redux/apiSlice/workshops.slice';
import { TRtkErrorType } from 'data/types/generic.types';
import ConfirmModalBody from 'components/Shared/ConfirmModalBody';
import ActionGroupItemLabel from 'components/Shared/ActionsButtonDetailsPage/ActionGroupItemLabel';
import { TActionProps } from '../Actions.types';

const CancelAction: FC<TActionProps> = ({ id }) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.workshops.details.actions.cancel',
  });
  const [open, setOpen] = useState(false);
  const { showToastNotification } = useShowToastNotification();

  const [cancel, { isLoading }] = useCancelActionMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      await cancel({
        workshopId: id,
      }).unwrap();
      showToastNotification({
        message: t('modal.SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
    handleClose();
  };

  return (
    <>
      <ActionGroupItemLabel
        label={t('CANCEL_BTN')}
        icon={EIconNames.CLOSE}
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        title={t('modal.TITLE')}
        cancelText={t('modal.CANCEL_BTN')}
        okText={t('modal.SUBMIT_BTN')}
        onCancel={handleClose}
        onOk={handleSubmit}
        confirmLoading={isLoading}
      >
        <ConfirmModalBody
          title={t('modal.SUBTITLE')}
          description={t('modal.DESCRIPTION')}
        />
      </Modal>
    </>
  );
};

export default CancelAction;
